import { ListActionProvider } from "@beeldit/core/actions/list/ListActionContext";
import { RemoveActionProvider } from "@beeldit/core/actions/remove/RemoveActionContext";
import { CreateActionProvider } from "../actions/create/CreateActionContext";
import departureBookingsConfig from "../departureBookingsConfig";
import DepartureTablePage from "../components/DepartureTablePage";
import { GenerateInvoiceActionProvider } from "../actions/generate-invoice/GenerateInvoiceActionContext";
import { PayActionProvider } from "../actions/pay/PayActionContext";
import { CancelActionProvider } from "../actions/cancel/CancelActionContext";
import { UncancelActionProvider } from "../actions/uncancel/UncancelActionContext";
import { EditActionProvider } from "../actions/edit/EditActionContext";
import { EditActionProvider as CustomerEditActionProvider } from "@main/customers/actions/edit/EditActionContext";
import { UnpayActionProvider } from "../actions/unpay/UnpayActionContext";
import { EmailActionProvider } from "../actions/email/EmailActionContext";
import { ExportActionProvider } from "@main/reports/actions/export/ExportActionContext";
import { GenerateInvoicePdfActionProvider } from "../actions/generate-invoice-pdf/GenerateInvoicePdfActionContext";
import { RegenerateInvoicePdfActionProvider } from "../actions/regenerate-invoice-pdf/RegenerateInvoicePdfActionContext";
import { GenerateDeliveryNoteActionProvider } from "../actions/generate-delivery-note/GenerateDeliveryNoteActionContext";
import { BulkActionActionProvider } from "@beeldit/core/context/BulkActionContext";

function DepartureBookingsPage() {
  const tablePageParams = {
    modelConfig: departureBookingsConfig, // Configuración del modelo
    formDefaultValues: null,
    filters: null,
    formFilterValues: null,
  };

  return (
     <BulkActionActionProvider>
    <ListActionProvider key={departureBookingsConfig.modelName}>
      <RemoveActionProvider>
        <CreateActionProvider>
          <PayActionProvider>
          <UnpayActionProvider>
            <CustomerEditActionProvider>
            <EditActionProvider>
              <CancelActionProvider>
                <UncancelActionProvider>
                  <EmailActionProvider>
                    <ExportActionProvider>
                      <GenerateDeliveryNoteActionProvider>
                          <GenerateInvoiceActionProvider>
                            <GenerateInvoicePdfActionProvider>
                              <RegenerateInvoicePdfActionProvider>
                                <DepartureTablePage {...tablePageParams} />
                              </RegenerateInvoicePdfActionProvider>
                            </GenerateInvoicePdfActionProvider>
                          </GenerateInvoiceActionProvider>
                      </GenerateDeliveryNoteActionProvider>
                    </ExportActionProvider>
                  </EmailActionProvider>
                </UncancelActionProvider>
              </CancelActionProvider>
            </EditActionProvider>
            </CustomerEditActionProvider>
            </UnpayActionProvider>
          </PayActionProvider>
        </CreateActionProvider>
      </RemoveActionProvider>
    </ListActionProvider>
    </BulkActionActionProvider>
  );
}

export default DepartureBookingsPage;
